import type { ReactNode } from "react";

/** Consistent header for all settings pages — smaller title with a mandatory description. */
export const SettingsHeader = ({
  title,
  description,
  badge,
  children,
}: {
  title: string;
  description: string;
  /** Optional badge rendered next to the title (e.g. a "Beta" tag) */
  badge?: ReactNode;
  /** Optional trailing content (e.g. action buttons) rendered on the right */
  children?: ReactNode;
}) => (
  <div className="flex items-start justify-between gap-4">
    <div className="select-none">
      <div className="flex items-center gap-2">
        <h1 className="font-semibold text-lg">{title}</h1>
        {badge}
      </div>
      <p className="text-muted-foreground text-sm">{description}</p>
    </div>
    {children}
  </div>
);
